import { MapPin, Video } from "lucide-react";

interface AppointmentLocationProps {
  address?: string | null;
  isTelehealth: boolean;
}

export function AppointmentLocation({
  address,
  isTelehealth,
}: AppointmentLocationProps) {
  if (isTelehealth) {
    return (
      <div className="inline-flex items-center gap-2 text-sm text-foreground">
        <span className="body-copy text-muted-foreground font-medium">
          Location:
        </span>
        <Video className="w-4 h-4 text-primary shrink-0" />
        <span className="body-copy">Telehealth</span>
      </div>
    );
  }

  if (!address) return null;

  return (
    <div className="inline-flex items-center gap-2 text-sm">
      <span className="body-copy text-muted-foreground font-medium">
        Location:
      </span>
      <a
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 body-copy text-primary hover:text-primary/80 transition-colors"
      >
        <MapPin className="w-4 h-4 shrink-0" />
        <span className="underline underline-offset-4">{address}</span>
      </a>
    </div>
  );
}
